<template lang="pug">
div
  v-container(fluid, grid-list-md)
    v-layout(row, wrap, align-center, justify-center)
      v-flex(xs2, class="d-flex justify-center")
        h2.headline Imagens DICOM
      v-flex(xs12)
        DropFile
</template>

<script>
import DropFile from '@/components/util/DropFile'

export default {
  name: 'UploadFiles',

  components: {
    DropFile
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/UploadFiles.vue